/**
 * Copyright © 2026 OwnersTable Inc. All rights reserved.
 * This source code is proprietary and confidential.
 * Unauthorized copying or distribution is strictly prohibited.
 */

import { Button, styled } from "@mui/material";

export const StyledButton = styled(Button)(() => ({
  '&.Mui-disabled':{
    backgroundColor: '#ebebeb',
  },
  fontSize: "0.875rem",
  textTransform: "none",
  fontWeight: 600,
  px: 2,
  border: "1px solid rgba(0,0,0,.12)",
  py: "6px",
  backgroundColor: "white",
  color: "#2b4fb9",
  "&:hover": {
    backgroundColor: "white",
  },
}));
